import { MainAppService } from "src/modules/app-template/services/main-app.service";
import { Objects } from "src/modules/utils/shared/objects";

export enum CalendarEventStartRelativeTo {
    //netgen start
    startDate = 0,
    deliveryDate1 = 1,
    deliveryDate2 = 2,
    deliveryDate3 = 3,
    task = 4
    //netgen end
}
export namespace CalendarEventStartRelativeTo{
    export function getName(value: CalendarEventStartRelativeTo): string {
        switch (value) {
            case CalendarEventStartRelativeTo.startDate:
                return "startDate";
            case CalendarEventStartRelativeTo.deliveryDate1:
                return "deliveryDate1";
            case CalendarEventStartRelativeTo.deliveryDate2:
                return "deliveryDate2";
            case CalendarEventStartRelativeTo.deliveryDate3:
                return "deliveryDate3";
            case CalendarEventStartRelativeTo.task:
                return "task";
            default:
                return Objects.toString(value);
        }
    }

    export function getDisplayName(value: CalendarEventStartRelativeTo, app: MainAppService): string {
        return app.t("entity.CalendarEventStartRelativeTo." + getName(value));
    }
}
